<template>
  <main id="content">
    <div class="l-main-content__inner">
      <div class="c-page-header">
        <h1 class="c-page-header-title">進級処理<span class="small">（生徒が入力）</span></h1>
        <div class="c-page-header__return">
          <a
            :href="`/teacher/class/${targetAcademicSessions?.from_academic_session.year}/student/next_grade`"
            class="c-button-white -return -teacher">
            <span class="label">戻る</span>
          </a>
        </div>
      </div>

      <template v-if="canNextGrade">
        <template v-if="fromAcademicYearStudentsRegistrationStatus">
          <p class="c-page-explanation -attention">
            新年度の学年・学級の登録は、生徒自身がマナビリア上で行います。<br>
            ※手順については<a href="https://manavi.wikipy.jp/teacher/p712" target="_blank">コチラ</a>をご参照ください。
          </p>

          <section v-if="isStudentsRegisteredInFromAcademicYear">

            <p class="p-grade-target-text display">
              <span class="target-year display">{{ targetAcademicSessions.from_academic_session.year }}年度 {{ fromAcademicYear() }}年生</span>を
              <span class="target-year display">{{ targetAcademicSessions.to_academic_session.year }}年度 {{ toAcademicYear }}年生</span>にする処理を行います
            </p>

            <div class="c-page-section">
              <ol class="c-step">
                <!-- STEP1 学級作成 -->
                <li class="item on" id="step1">
                  <div class="item__inner">
                    <div class="item__title">
                      <figure>
                        <figcaption>STEP1</figcaption>
                        <img
                          src="../../../../djangoapp/assets/teacher/img/common/icon_make_class.png"
                          alt="add classroom"
                        >
                      </figure>
                    </div>
                    <div class="item__body">
                      <div class="title">
                        学級作成
                      </div>
                      <div class="body -top">
                        <div>
                          <p class="text">
                            進級後の生徒を所属させる新しい学級（{{ targetAcademicSessions.to_academic_session.year }}年度 {{ toAcademicYear }}年生の学級）を作成します。
                          </p>
                          <div class="p-grade-frame">
                            <div class="p-grade-frame-title-wrapper">
                              <p class="p-grade-frame-title">{{ targetAcademicSessions.to_academic_session.year }}年度 {{ toAcademicYear }}年生の学級</p>
                              <button class="c-button-white -prefix-icon -reload" @click="reloadClassrooms">
                                <span class="label">登録内容の確認</span>
                              </button>
                            </div>
                            <div class="p-grade-frame-contents">
                              <ul v-if="toClassrooms">
                                <li v-for="classroom in toClassrooms" :key="classroom.id">{{ classroom.name }}</li>
                              </ul>
                              <ul v-else>
                                <li>まだ登録されていません</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="btn -wide">
                          <a
                            :href="`/teacher/class/add/?academic_session_year=${targetAcademicSessions.to_academic_session.year}&academic_year=${toAcademicYear}`"
                            target="_blank"
                            class="c-button-blue -arrow -type01"
                          >
                            <span class="label">学級登録画面へ</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <!-- STEP2 生徒にアナウンス -->
                <li class="item on" id="step2">
                  <div class="item__inner">
                    <div class="item__title">
                      <figure>
                        <figcaption>STEP2</figcaption>
                        <img
                          src="../../../../djangoapp/assets/teacher/img/common/icon_speaker.svg"
                          alt="announcement to students"
                        >
                      </figure>
                    </div>
                    <div class="item__body">
                      <div class="title">
                        生徒にアナウンス
                      </div>
                      <div class="body">
                        <p class="text">
                          マナビリアへログインして新年度の学級の選択と出席番号の入力を行うよう、<br>
                          口頭または配布物などで生徒へご指示をお願いします。<br>
                          <br>
                          生徒のマナビリア画面
                          <img
                            src="../../../../djangoapp/assets/teacher/img/common/img_student_screen.png"
                            alt="stundet screen"
                            width="900"
                            class="p-grade-student-screen"
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </li>

                <!-- 進級状況を確認 -->
                <li class="item on">
                  <div class="item__inner">
                    <div class="item__title">
                      <figure>
                        <img
                          src="../../../../djangoapp/assets/teacher/img/common/icon_regi_step_comp.png"
                          alt="complete"
                          class="adjust3"
                        >
                      </figure>
                    </div>
                    <div class="item__body">
                      <div class="title">
                        進級状況を確認
                      </div>
                      <div class="body">
                        <p class="text">
                          生徒の入力状況は「<a :href="toAcademicSessionClassroomListUri()" target="_blank" class="c-parts-link">学級・生徒管理画面</a>→生徒名簿一覧」からご確認ください。<br>
                          誤った選択／入力をした生徒や、入力を行わない生徒の新学級・出席番号の修正は<br>
                          「<a :href="toAcademicSessionClassroomListUri()" target="_blank" class="c-parts-link">学級・生徒管理画面</a>→生徒名簿一覧→編集」からできます。
                          <span class="u-text-alert u-text-block">※すべての生徒が進級処理を完了するまで、宿題を配信できない場合があります。</span>
                        </p>
                      </div>
                      <div class="backLink">
                        <a
                          :href="toAcademicSessionClassroomListUri()"
                          class="c-button-blue -arrow -type01"
                        >
                          <span class="label">学級・生徒管理画面へ</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </li>
              </ol>
            </div>

          </section>

          <div
            v-else
            class="c-frame-message"
          >
            <p class="c-parts-error-message -center">
              {{ targetAcademicSessions.from_academic_session.year }}年度{{ fromAcademicYear() }}年生に進級処理が可能な生徒の登録がありません。<br>
              詳しくは
              <a
                href="https://manavi.wikipy.jp/teacher/p712"
                target="_blank"
                class="c-parts-link"
              >サポートページ</a>
              を参照してください。
            </p>
          </div>
        </template>
      </template>

      <div
        v-else
        class="c-frame-message"
      >
        <p class="c-parts-error-message -center">
          {{ academicSessionYear }}年度は、現在進級処理できない年度です。現在進級処理できるのは、{{ targetAcademicSessions?.from_academic_session.year }}年度の生徒です。<br>
          詳しくは
          <a
            href="https://manavi.wikipy.jp/teacher/p712"
            target="_blank"
            class="c-parts-link"
          >サポートページ</a>
          を参照してください。
        </p>
      </div>
    </div>
    <error-modal></error-modal>
  </main>
</template>

<script setup lang="ts">
  import { ref, computed, onMounted } from "vue";
  import { ITargetAcademicSessions, IStudentsRegistrationStatus, IAcademicYearClass } from "@/consts/interfaces";
  import { useNextGradeStore } from "@/store/teacher/next_grade_store";
  import { useLearningProgressStore } from "@/store/teacher/learning_progress_store";

  const nextGradeStore = useNextGradeStore()

  const learningProgressStore = useLearningProgressStore()

  const props = defineProps<{
    // 先生が選択した進級元年度
    academicSessionYear: number,
    // 先生が選択した進級先学年
    toAcademicYear: number
  }>();

  // 進級対象年度(進級元年度/進級先年度)
  const targetAcademicSessions =  ref<ITargetAcademicSessions>(null);
  // 進級元学年の生徒登録状況
  const fromAcademicYearStudentsRegistrationStatus = ref<Array<IStudentsRegistrationStatus>>(null);

  // 進級可能な年度である
  const canNextGrade = ref<boolean>(true);
  // 進級元の学年に生徒が登録されている
  const isStudentsRegisteredInFromAcademicYear = ref<boolean>(true);

  const academicYearsClassrooms = ref<IAcademicYearClass>(null)

  // toAcademicSessionIdとtoAcademicYearに一致する、進級先年度・進級先学年の学級を返す
  // FIXME: この処理はacademicYearsClassroomsから絞り込んでいるので、処理が重くなるなどあれば、必要なデータのみ受け取るように変更する
  const toClassrooms = computed(() => {
    // APIが実行されていない場合、値がセットされないのでnullを返す
    if (!academicYearsClassrooms.value) return null

    const toAcademicSessionId = targetAcademicSessions.value.to_academic_session.id
    const toAcademicYear = props.toAcademicYear

    // 学級がないと画面遷移できないため、classroomが存在しないケースは考慮しない
    const classrooms = academicYearsClassrooms.value.classrooms

    return classrooms[toAcademicSessionId]?.[toAcademicYear] ?? null
  })

  onMounted(async() => {
    targetAcademicSessions.value = await nextGradeStore.fetchAcademicSessions()

    if (targetAcademicSessions.value.from_academic_session.year !== props.academicSessionYear) {
      canNextGrade.value = false
      return
    }

    fromAcademicYearStudentsRegistrationStatus.value = await nextGradeStore.fetchStudentsRegistrationStatus(
      {
        academic_session: targetAcademicSessions.value.from_academic_session.id,
        academic_year: fromAcademicYear(),
      }
    )

    // 学年を指定して学年別生徒登録状況を取得しているため、
    // fromAcademicYearStudentsRegistrationStatus の要素数は常に1 (指定した学年の分のみ)
    if (!fromAcademicYearStudentsRegistrationStatus.value[0].is_registered) {
      isStudentsRegisteredInFromAcademicYear.value = false
      return
    }

    academicYearsClassrooms.value = await learningProgressStore.fetchYearClass()
  })

  function fromAcademicYear() {
    return props.toAcademicYear - 1
  }

  // 進級先年度の学級・生徒管理画面へのURI
  function toAcademicSessionClassroomListUri() {
    return `/teacher/class/?academic_session_year=${targetAcademicSessions.value.to_academic_session.year}`
  }

  // 学級情報を再取得
  async function reloadClassrooms() {
    academicYearsClassrooms.value = await learningProgressStore.fetchYearClass()
  }


</script>
